import { gql } from '@apollo/client'

export const PERSONALIZED_ADDRESS_FRAGMENT = gql`
  fragment PersonalizedAddress on PersonalizedAddressInterface {
    firstName
    lastName
    address1
    address2

    city
    country
    countryIsoCode
    stateIsoCode
    zipCode
  }
`
